module.exports = __webpack_public_path__ + "static/media/signup.7760ab54.png";